import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/draft";
import { PageHead } from "@/pages/ComoFunciona";

export default function Areas() {
  const [cats, setCats] = useState([]);
  useSeo("Áreas jurídicas", "Conheça as áreas do Direito disponíveis para envio de solicitações na Conexão Litigium.");
  useEffect(() => {
    api.get("/public/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);
  return (
    <>
      <PageHead eyebrow="Áreas jurídicas" title="Escolha a área ou deixe a triagem conosco." text="Não sabe identificar? Selecione a opção correspondente e descreva a situação." />
      <section className="wrap mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="areas-grid">
        {cats.map((c) => (
          <Link key={c.slug} to={`/solicitar?tipo=pf&area=${c.slug}`} className="select-card group" data-testid={`area-link-${c.slug}`}>
            <h3 className="font-bold">{c.name}</h3>
            <p className="mt-1 text-sm text-[#64748B]">{c.description}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-[#1465C8]">Solicitar <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
          </Link>
        ))}
      </section>
    </>
  );
}
